import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useContext, useSyncExternalStore } from 'react'

import ProfileContext from '@/components/Context/ProfileContext'
import getEnvVar from '@/lib/getEnvVar'
import {
  isRecoVariantOverride,
  readRecoVariantOverride,
  writeRecoVariantOverride,
} from '@/lib/recoVariantOverride'

const AUTO = 'auto'

const noSubscription = () => () => {}

// Outil de recette, hors production : libelles en dur comme le reste du bandeau.
const RECO_OPTIONS = [
  { value: AUTO, label: 'Auto', title: 'Bras naturel du compte (répartition par user_id)' },
  { value: 'A', label: 'A · témoin', title: 'Blocs historiques, listes brutes' },
  { value: 'B', label: 'B · nouveau', title: 'Nouveau moteur : règles, nouveaux blocs, preuve sociale' },
]

// Bandeau statique au-dessus du layout (dans le flux, pas en position fixed) :
// il pousse la page vers le bas et ne recouvre jamais les overlays (recherche...).
// A droite : bras du test A/B des recommandations, forcable pour ce navigateur.
const DevelopmentBanner: React.FC = () => {
  const { profile } = useContext(ProfileContext)
  // Cote serveur : toujours « Auto » (le cookie n'y est pas lu), le navigateur prend le relais a
  // l'hydratation. Le cookie ne change qu'avec un rechargement : rien a ecouter.
  const recoChoice = useSyncExternalStore(
    noSubscription,
    () => readRecoVariantOverride() ?? AUTO,
    () => AUTO
  )

  if (getEnvVar('APP_ENV') == 'production') {
    return null
  }

  const handleRecoChange = (_event: React.MouseEvent<HTMLElement>, value: string | null) => {
    if (!value || value === recoChoice) return
    writeRecoVariantOverride(isRecoVariantOverride(value) ? value : null)
    // Profil et blocs sont en cache cote client : on recharge pour tout relire dans le bon bras
    window.location.reload()
  }

  const currentArm = profile?.recommendVariant

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '24px',
        backgroundColor: '#ff6b35',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          letterSpacing: '1px',
        }}
      >
        🛠️ Environnement de Développement
      </Typography>

      <Box
        sx={{
          position: 'absolute',
          right: 8,
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography sx={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>
          Reco{currentArm ? ` (bras ${currentArm})` : ''} :
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={recoChoice}
          onChange={handleRecoChange}
          aria-label="Bras du test A/B des recommandations"
        >
          {RECO_OPTIONS.map(option => (
            <ToggleButton
              key={option.value}
              value={option.value}
              title={option.title}
              sx={{
                height: 18,
                px: 1,
                py: 0,
                fontSize: '11px',
                lineHeight: 1,
                textTransform: 'none',
                color: 'white',
                borderColor: 'rgba(255,255,255,0.6)',
                '&.Mui-selected, &.Mui-selected:hover': {
                  backgroundColor: 'white',
                  color: '#ff6b35',
                  fontWeight: 'bold',
                },
              }}
            >
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  )
}

export default DevelopmentBanner
